import {inject, observer} from 'mobx-react';
import PropTypes from 'prop-types';
import React, {Component} from 'react';

//helpers
import {NormalizedSearchResultPropType} from '@swipe-guide/clients-shared/utils/search-result-utils';

//components
import {FormattedMessage} from '@swipe-guide/clients-shared/components/FormattedComponents';

//messages
import messages from './messages';

//styles
import {
  Content,
  DropdownTitle,
  DropdownTitleInner,
  GenericWrapper,
  MoreLink,
  NoResults,
  SearchBarDropdown,
  Spinner,
  StyledResultRow,
  SubSection,
  SubSectionWrapper,
  WarningIcon
} from './styles';

@inject('store')
@observer
class BaseSearchBarDropdownComponent extends Component {
  static defaultProps = {
    maxResults: Infinity
  };

  static propTypes = {
    genericResults: PropTypes.arrayOf(NormalizedSearchResultPropType),
    guideResults: PropTypes.arrayOf(NormalizedSearchResultPropType),
    hasError: PropTypes.bool,
    introSectionContent: PropTypes.node,
    introSectionTitle: PropTypes.node,
    isLoading: PropTypes.bool,
    onModeToggleClick: PropTypes.func,
    maxResults: PropTypes.number
  };

  renderResultsSection = (results, titleMessage) => {
    const {hasError, maxResults, store} = this.props;
    const {explorerPage} = store;
    const {goToSearchPage} = explorerPage;

    if (hasError || !results) {
      return null;
    }

    return (
      <SubSectionWrapper>
        <SubSection>
          <FormattedMessage {...titleMessage} />
        </SubSection>
        {results.length ? (
          results.slice(0, maxResults).map(result => <StyledResultRow key={result.id} result={result} />)
        ) : (
          <NoResults>
            <FormattedMessage {...messages.searchPage_noResults} />
          </NoResults>
        )}
        {results.length > maxResults && (
          <GenericWrapper align="right">
            <MoreLink onClick={goToSearchPage}>
              <FormattedMessage {...messages.searchPage_viewAllResults} />
            </MoreLink>
          </GenericWrapper>
        )}
      </SubSectionWrapper>
    );
  };

  render() {
    const {isLoading, genericResults, guideResults, hasError, introSectionContent, introSectionTitle} = this.props;

    return (
      <SearchBarDropdown>
        <DropdownTitle>
          <DropdownTitleInner>
            <FormattedMessage {...messages.searchPage_dropDownTitle} />
          </DropdownTitleInner>
        </DropdownTitle>
        <Content isTransparent={isLoading}>
          {introSectionContent && (
            <SubSectionWrapper>
              <SubSection>{introSectionTitle}</SubSection>
              {introSectionContent}
            </SubSectionWrapper>
          )}
          {hasError && (
            <SubSectionWrapper>
              <SubSection>
                <FormattedMessage {...messages.error} />
              </SubSection>
              <GenericWrapper>
                <WarningIcon />
                <FormattedMessage {...messages.errorFetchingResults} />
              </GenericWrapper>
            </SubSectionWrapper>
          )}
          {this.renderResultsSection(genericResults, messages.searchPage_searchResults)}
          {this.renderResultsSection(guideResults, messages.searchPage_guides)}
        </Content>
        {isLoading && <Spinner />}
      </SearchBarDropdown>
    );
  }
}

export default BaseSearchBarDropdownComponent;
